

















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
import EventApi from "../../api/EventsApi";

@Component({
    components: {},
    props: {},
})

export default class NewRoundModal extends Vue {

    /**
     * Закрыть модалку
     * @private
     */
    private closeModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('close-modal');
    }

    /**
     * Начать новый раунд
     * @private
     */
    private startNewRound(): void {
        this.$emit('start-new-round');
        this.closeModal();
    }

}
